export default __webpack_public_path__ + "static/media/ec2.950810a6.svg";